(ns io.daskul.tutorial.webapp.app.events
  (:require
   [re-frame.core :as rf]
   [ajax.core :as ajax]
   [io.daskul.tutorial.webapp.app.db :as app.db]
   [io.daskul.tutorial.webapp.shared.api.client :as client]
   [io.daskul.webapp.aggregates.events :as lib.agg.events]
   [io.daskul.webapp.panel.events :as panel.events]))

(rf/reg-event-db
 ::initialize-db
 (fn [_ _]
   app.db/default-db))

;; ============================================================================
;; School info (public endpoint, fetched before login)
;; ============================================================================

(rf/reg-event-fx
 ::fetch-school-info
 (fn [_ [_ school-code]]
   {:http-xhrio {:method :get
                  :uri (str client/api-url "/public/schools/" school-code)
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success [::fetch-school-info-success]
                  :on-failure [::fetch-school-info-failure]}}))

(rf/reg-event-db
 ::fetch-school-info-success
 (fn [db [_ response]]
   (assoc db :school-info response)))

(rf/reg-event-db
 ::fetch-school-info-failure
 (fn [db [_ _error]]
   (assoc db :school-info {:error true})))

(rf/reg-sub
 ::school-info
 (fn [db]
   (:school-info db)))

(rf/reg-sub
 ::school-name
 :<- [::school-info]
 (fn [info]
   (:name info)))

(rf/reg-sub
 ::school-not-found?
 :<- [::school-info]
 (fn [info]
   (:error info)))

;; ============================================================================
;; Lib Event Callbacks (navigation + panel cleanup after CRUD success)
;; ============================================================================

;; After successful create: navigate to edit page
(rf/reg-event-fx :webapp/on-create-success
  (fn [{:keys [db]} [_ agg-key response]]
    (let [id (:id response)
          resource (lib.agg.events/get-resource-name agg-key)]
      {:db (panel.events/close-panel-db db)
       :dispatch [:io.daskul.tutorial.webapp.router/navigate
                  :aggregate/detail {:agg resource :id id}]})))

;; After successful patch: no navigation needed (stay on edit page)
(rf/reg-event-fx :webapp/on-patch-success
  (fn [{:keys [db]} [_ _agg-key _response]]
    {:db db}))

;; After successful delete: navigate to list page
(rf/reg-event-fx :webapp/on-delete-success
  (fn [{:keys [db]} [_ agg-key _id]]
    (let [resource (lib.agg.events/get-resource-name agg-key)]
      {:db (panel.events/close-panel-db db)
       :dispatch [:io.daskul.tutorial.webapp.router/navigate
                  :aggregate/list {:agg resource}]})))
